import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-box"
};
const _hoisted_2 = {
  class: "login-code"
};
const _hoisted_3 = {
  class: "login-password"
};
const _hoisted_4 = {
  class: "submit-btn"
};
import { reactive, ref, onMounted } from 'vue';
import { login, getAuthCodeBase64 } from "@/api/login";
import { Tool } from '../config/tool';
import { storeToRefs } from 'pinia';
import { user } from '../store/user';
import { useRouter, useRoute } from 'vue-router';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'Login',
  setup(__props) {
    const router = useRouter();
    const userStore = user();
    const loginCode = ref(''); // 登录账号
    const password = ref(''); // 登录密码
    const authCode = ref(''); // 图片验证码
    const authKey = ref(''); // 获取图片验证返回的key 登录用
    const imagePath = ref(''); // 获取图片验证码返回的验证码图片
    const fingerprint = ref(null); //- 指纹
    // 取消
    const cancelHandle = () => {
      router.push({
        path: '/',
        query: {}
      });
    };

    // 提交
    const submitHandle = async () => {
      let fingerprintPassword = fingerprint ? fingerprint + ';;;' + password.value : 'NULL;;;' + password.value;
      const encrytPassword = Tool.Encrypt(fingerprintPassword); //- 密码加密

      let params = {
        loginCode: loginCode.value,
        password: encrytPassword,
        isEncrypt: 0,
        //- 密码是否加密 
        userAgent: 1,
        //- 来源  客户端登录 不用传验证码
        // authKey: authKey.value,
        // authCode: authCode.value
        // userAgent: 1, // 客户端登录 不用传验证码
        version: '4.2.4.0',
        autoLgn: false,
        pc_guid: 'e453cd4ab131a7168d34ddda8c6f0731'
      };
      login(params).then(res => {
        if (res.success) {
          console.log('res', res);
          if (res.data.token && res.data.id) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userId', res.data.id);
            userStore.setUserInfo(res.data);
            ElMessage({
              message: '登录成功',
              type: 'success'
            });
            router.push({
              path: '/',
              query: {}
            });
          }
        } else {
          getAuthCode();
        }
      }).catch(err => {
        console.log('err', err);
      });
    };

    // 获取图片验证码
    const getAuthCode = () => {
      authCode.value = '';
      getAuthCodeBase64().then(res => {
        if (res && res.image && res.key) {
          imagePath.value = 'data:image/jpeg;base64,' + res.image;
          authKey.value = res.key;
          console.log('获取图片验证码', res);
        }
      }).catch(err => {
        console.log('err', err);
      });
    };
    onMounted(() => {
      getAuthCode();
      // console.log(store.state.userInfo)
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "title"
      }, "登录", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: loginCode.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginCode.value = $event),
        style: {
          "width": "240px"
        },
        placeholder: "请输入账号"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => password.value = $event),
        style: {
          "width": "240px"
        },
        type: "password",
        placeholder: "Please input password",
        "show-password": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        onClick: cancelHandle
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("取消")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: submitHandle
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("登录")])),
        _: 1
      })])]);
    };
  }
};